// extracted by mini-css-extract-plugin
var _1 = "ChatroomSystemMessage-modulecomment__GVqUQ";
var _2 = "ChatroomSystemMessage-modulecommentButton__vqlKU Link-modulelink__btW0L";
var _3 = "ChatroomSystemMessage-modulecommentContent__fU1Nl";
var _4 = "ChatroomSystemMessage-modulelink__LFIMu";
var _5 = "ChatroomSystemMessage-modulerow__Yfdah";
var _6 = "ChatroomSystemMessage-moduletext__wF7zl";
var _7 = "ChatroomSystemMessage-moduletime__dD5lM";
export { _1 as "comment", _2 as "commentButton", _3 as "commentContent", _4 as "link", _5 as "row", _6 as "text", _7 as "time" }
